import React from "react";
import { Snackbar, Alert } from "@mui/material";

const NotificationSnackbar = ({ open, onClose, message, severity }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }} 
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{
          width: "100%",
          maxWidth: "400px",
          wordWrap: "break-word",
          whiteSpace: "pre-wrap",
          backgroundColor:
            severity === "success"
              ? "#408140"
              : severity === "error"
              ? "#C62828"
              : severity === "warning"
              ? "#ff9800"
              : "#2196f3",
          color: "white",
          '& .MuiAlert-icon': { color: "white" },
          fontSize: "0.875rem",
          lineHeight: 1.5,
          padding: "16px",
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationSnackbar;